import { getCopiedElement } from "@topol/utils";

export default async () => {
  try {
    const clipboardContents = await navigator.clipboard.readText();

    return getCopiedElement(clipboardContents);
  } catch (error) {
    return;
  }
};
